export default [
    "PhD",
    "Masters (or equivalent)",
    "Honours",
    "Undergraduate",
    "other"
]